var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"uncombat_unknockout"}},[_vm._v("uncombat_unknockout")])
}
var staticRenderFns = []

export { render, staticRenderFns }